function toResponseInit(response) {
  return {
    status: response.status,
    statusText: response.statusText,
    headers: Object.fromEntries(response.headers.entries())
  };
}
export {
  toResponseInit
};
//# sourceMappingURL=toResponseInit.mjs.map